import React from 'react';
import './LoadingSpinner.css';

export default function LoadingSpinner({ text = 'Procesando...' }) {
    return (
        <div className="spinner-container" role="status" aria-label={text}>
            <div className="spinner">
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
            </div>
            <p className="spinner-text">{text}</p>
        </div>
    );
}
